import * as yup from "yup";

const coachReviewSchema = yup.object().shape({
    home: yup
        .object({
            headCoach: yup.number().optional().nullable(),
            asstCoach: yup.number().optional().nullable(),
            spectators: yup.number().optional().nullable(),
            overall: yup.number().optional().nullable(),
        })
        .optional(),
    visitor: yup
        .object({
            headCoach: yup.number().optional().nullable(),
            asstCoach: yup.number().optional().nullable(),
            spectators: yup.number().optional().nullable(),
            overall: yup.number().optional().nullable(),
        })
        .optional(),
});

export default coachReviewSchema;
